<div class="generales">
  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando">
  <h1 class="titutlo">{{'SECCIONES.CALIFICACIONFINAL.TITULO'| translate}}</h1>

<!-- <img src="assets/images/norm35/resuTest/NORMA35_DEMO_CALIFICACION_FINAL.jpg" alt=""> -->
<div fxLayout="row" fxLayoutAlign="space-around start" >
  <div class="calificacion">
  <table>
  <tr>
    <td [ngClass]=" color == '4'? 'classAlto': 'classNulo'
    && color == '2' ? 'classBajo': 'classNulo'
    && color == '3' ? 'classMedio': 'classNulo'
    && color == '5' ? 'classMuyAlto': 'classNulo'">
      <h1>{{'SECCIONES.RANGOS.'+color | translate}} {{calificacion}}</h1>
    </td>
    <td>
      <h3>{{'SECCIONES.CALIFICACIONFINAL.TEXTOCALIFICACION.'+totalColaboradores+'.'+color | translate}}</h3>
    </td>
  </tr>
  </table>
  </div> &nbsp;&nbsp;&nbsp;

<div  class="instrucciones">
  <table>
  <tr>
    <td style="background-color: #FF0000;">&nbsp; {{'SECCIONES.RANGOS.5'| translate}} &nbsp;</td>
    <td style="background-color: #FFFF00;">{{'SECCIONES.RANGOS.3'| translate}}</td>
  </tr>

  <tr>
    <td style="background-color: #FFC000;">{{'SECCIONES.RANGOS.4'| translate}}</td>
    <td style="background-color: #92D050;">{{'SECCIONES.RANGOS.2'| translate}}</td>
  </tr>

  <tr>
    <td style="background-color: #00b0f0;" colspan="2">{{'SECCIONES.RANGOS.1'| translate}}</td>
  </tr>
  </table>
  <p><strong>{{'SECCIONES.NOTATITULO'| translate}}</strong>{{'SECCIONES.CALIFICACIONFINAL.NOTA'| translate}}</p>
</div>
</div> <br>
</div>
</div>
